import React from 'react';
import { createPortal } from 'react-dom';
import { FaCheckCircle, FaExclamationCircle, FaTimes } from 'react-icons/fa';

const NotificationToast = ({ notification, onClose, mounted }) => {
  if (!mounted || !notification) return null;

  return createPortal(
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center z-[10000] pointer-events-none">
      <div className={`pointer-events-auto transform transition-all duration-300 ease-out ${
        notification ? 'translate-y-0 opacity-100 scale-100' : 'translate-y-4 opacity-0 scale-95'
      }`}>
        <div className={`flex items-center space-x-3 px-6 py-4 rounded-lg shadow-2xl border-2 min-w-[320px] max-w-md ${
          notification.type === 'success' 
            ? 'bg-gradient-to-r from-green-50 to-emerald-50 border-green-300 text-green-800' 
            : 'bg-gradient-to-r from-red-50 to-rose-50 border-red-300 text-red-800'
        }`}>
          <div className={`flex-shrink-0 ${
            notification.type === 'success' ? 'text-green-600' : 'text-red-600'
          }`}>
            {notification.type === 'success' ? (
              <FaCheckCircle className="w-6 h-6" />
            ) : (
              <FaExclamationCircle className="w-6 h-6" />
            )}
          </div>
          <div className="flex-1">
            <p className="text-sm font-semibold leading-relaxed">
              {notification.message}
            </p>
          </div>
          <button
            onClick={onClose}
            className={`flex-shrink-0 ml-2 p-1 rounded-full hover:bg-opacity-20 transition-colors ${
              notification.type === 'success' ? 'text-green-600 hover:bg-green-600' : 'text-red-600 hover:bg-red-600'
            }`}
          >
            <FaTimes className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default NotificationToast;

